var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterBackgroundVectors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 112,
    viewBox: "0 0 375 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.6,
    clipPath: "url(#clip0_2906_8991)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.746 -68.9936C126.977 -68.9936 106.898 -48.9983 106.898 -24.3327C106.898 0.332763 126.977 20.3281 151.746 20.3281C176.515 20.3281 196.594 0.332771 196.594 -24.3327C196.594 -48.9983 176.515 -68.9936 151.746 -68.9936Z",
    fill: "#B7CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376 20.3359L286.297 -68.9928L286.297 20.3359L376 20.3359Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M196.6 109.664L106.896 20.3353L106.896 109.664L196.6 109.664Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.594 6.37499L286.297 6.375L286.297 0.793278L196.594 0.79327L196.594 6.37499Z",
    fill: "#081E54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M286.311 20.3317L286.311 14.75L196.607 14.75L196.607 20.3317L286.311 20.3317Z",
    fill: "#081E54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0426 -68.9936C37.2737 -68.9936 17.1945 -48.9983 17.1945 -24.3327C17.1945 0.332763 37.2737 20.3281 62.0426 20.3281C86.8115 20.3281 106.891 0.332771 106.891 -24.3327C106.891 -48.9983 86.8115 -68.9936 62.0426 -68.9936Z",
    fill: "#0D318B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.42738 20.3359L3.17773 20.3359L3.17774 -68.9928L-2.42738 -68.9928L-2.42738 20.3359Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1933 -69L11.5881 -69L11.5881 20.3287L17.1932 20.3287L17.1933 -69Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-27.6606 20.3353L-27.6606 109.664C-2.89341 109.664 17.1875 89.667 17.1875 65.0032C17.1875 40.3394 -2.8934 20.3423 -27.6606 20.3423L-27.6606 20.3353Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0414 109.665L62.0414 20.3359C37.2743 20.3359 17.1934 40.333 17.1934 64.9968C17.1933 89.6606 37.2743 109.658 62.0414 109.658L62.0414 109.665Z",
    fill: "#B7CCFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0426 20.3353L62.0426 109.664C86.8097 109.664 106.891 89.667 106.891 65.0032C106.891 40.3394 86.8097 20.3423 62.0426 20.3423L62.0426 20.3353Z",
    fill: "#0D318B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2906_8991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 377,
    fill: "white",
    transform: "translate(376 -0.394531) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBackgroundVectors);
export default __webpack_public_path__ + "static/media/FooterBackgroundVectors.a91d9071c0bdfa12cd110122b15c435c.svg";
export { ForwardRef as ReactComponent };